import { useState } from 'react'
import Modal from '../Modal'
import ContentFeedEditForm from './ContentFeedEditForm'
import SearchParameters from '../content/search/searchParameters'
import { useNavigate } from 'react-router-dom'
import { ContentFeedView } from '../../api/client'
import { toastSuccess } from '../Notification'

type Props = {
    searchParameters: SearchParameters
    contentFeed?: ContentFeedView
}

/**
 * Modal that allows the user to remove content from the spam model
 */
export default function ContentFeedEditDialog({ searchParameters, contentFeed }: Props) {
    const [open, setOpen] = useState(false)
    const navigate = useNavigate()
    return (
        <div>
            <button
                onClick={() => setOpen(true)}
                className={
                    'relative inline-flex h-9 items-center space-x-2 px-3 py-2 text-[13px] rounded-md shadow-sm text-ink-700 bg-white border border-ink-200 hover:border-ink-300 hover:bg-ink-50 focus:outline-none focus:ring-1 focus:ring-arwen-500 focus:border-arwen-500'
                }
            >
                Save...
            </button>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                title="Save your search as a feed"
                size="sm"
            >
                <ContentFeedEditForm
                    searchParameters={searchParameters}
                    contentFeed={contentFeed}
                    onCompleted={(newContentFeedId: number, isNew: boolean) => {
                        // Dismiss the dialog
                        setOpen(false)
                        // We're only going to re-direct if we're creating a new feed...
                        if (isNew) {
                            navigate(`/content-search/feed/${newContentFeedId}`)
                            toastSuccess('Feed created')
                        } else {
                            // ... but if we're saving then we'll only display a toast
                            toastSuccess('Feed saved')
                        }
                    }}
                />
            </Modal>
        </div>
    )
}
